var _rect, _path, _path2, _path3, _rect2, _path4, _path5, _path6, _rect3, _path7, _path8, _path9, _circle, _rect4, _path10, _rect5, _path11, _rect6, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _path12, _path13, _path14;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPersistenceCarFreeDays(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 287,
    height: 140,
    viewBox: "0 0 287 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 35,
    width: 64,
    height: 64,
    rx: 32,
    fill: "#2F6FEB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.1543 49.1543L38.5389 84.8466",
    stroke: "white",
    strokeWidth: 2.46154,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.1268 51.6152H53.5221H45.0722L39.9772 51.6153C38.902 51.6153 38.2278 52.5652 37.8102 53.5561L35.1101 59.9621C32.3898 63.0389 32.3884 64.7551 32.3869 66.4084C32.3869 66.5158 32.3868 66.623 32.3859 66.7302C32.3859 66.7364 32.3856 66.7427 32.3853 66.7489C32.3851 66.7555 32.3848 66.7621 32.3848 66.7687V66.9089V68.5313C32.3847 70.3908 32.9332 72.1235 34.0804 73.3447V78.5447C34.0804 79.3841 34.756 80.0597 35.5954 80.0597H36.8589C37.6983 80.0597 38.3739 79.3841 38.3739 78.5447V74.1148H41.9065L50.7547 61.0348C50.162 61.0108 49.6081 60.9972 49.1194 60.9976C45.5717 61.0005 38.5045 61.7702 38.5045 61.7702C38.0084 61.7705 37.444 61.3424 37.6087 60.8744L39.42 55.7287C39.5847 55.2607 39.8197 54.8328 40.3158 54.8328H54.9502L57.1268 51.6152Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.2139 74.1152H60.1465V78.5451C60.1465 79.3845 60.8221 80.0601 61.6615 80.0601H62.925C63.7644 80.0601 64.44 79.3845 64.44 78.5451V73.4203C65.6369 72.1955 66.2102 70.4304 66.2102 68.5317V66.9093C66.21 66.9009 66.2101 66.8931 66.2101 66.8852C66.2102 66.8801 66.2102 66.8749 66.2102 66.8695V66.7691C66.2102 66.7278 66.2084 66.6871 66.2065 66.6462C66.206 66.6339 66.2054 66.6216 66.2049 66.6092C66.2029 66.4862 66.2016 66.3655 66.2003 66.2466C66.1806 64.4004 66.1655 62.9948 63.4846 59.9625L60.785 53.5564C60.7031 53.3619 60.6112 53.1689 60.5083 52.9844L58.8938 55.371C58.9514 55.4827 59.0007 55.6045 59.0453 55.7291L60.8888 60.8748C61.0561 61.3418 60.4891 61.7709 59.9929 61.7706C59.9929 61.7706 57.6056 61.5148 54.8846 61.2976L46.2139 74.1152Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 201,
    y: 27,
    width: 80,
    height: 80,
    rx: 40,
    fill: "#2F6FEB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M258.692 44.6914L227.923 89.3068",
    stroke: "white",
    strokeWidth: 3.07692,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M251.159 47.7695H246.653H236.091L229.722 47.7696C228.378 47.7696 227.535 48.957 227.013 50.1956L223.638 58.2031C220.238 62.0491 220.236 64.1944 220.234 66.261C220.234 66.3953 220.234 66.5292 220.233 66.6632C220.233 66.671 220.233 66.6788 220.232 66.6866C220.232 66.6948 220.231 66.7031 220.231 66.7113V66.8867V68.9146C220.231 71.2389 220.917 73.4049 222.351 74.9314V81.4314C222.351 82.4806 223.195 83.3251 224.245 83.3251H225.824C226.873 83.3251 227.718 82.4806 227.718 81.4314V75.894H232.134L243.194 59.544C242.453 59.514 241.761 59.4969 241.15 59.4975C236.715 59.5011 227.881 60.4632 227.881 60.4632C227.261 60.4636 226.555 59.9284 226.761 59.3435L229.025 52.9113C229.231 52.3264 229.525 51.7915 230.145 51.7915H248.438L251.159 47.7695Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M237.518 75.894H254.933V81.4314C254.933 82.4806 255.778 83.3251 256.827 83.3251H258.407C259.456 83.3251 260.3 82.4806 260.3 81.4314V75.0253C261.796 73.4944 262.513 71.288 262.513 68.9146V66.8867C262.513 66.8694 262.513 66.8541 262.513 66.8369V66.7113C262.513 66.6598 262.511 66.6088 262.508 66.5577C262.508 66.5424 262.507 66.527 262.506 66.5115C262.504 66.3577 262.502 66.2069 262.501 66.0583C262.476 63.7505 262.457 61.9935 259.106 58.2031L255.732 50.1955C255.629 49.9523 255.514 49.7111 255.386 49.4805L253.367 52.4638C253.44 52.6034 253.501 52.7557 253.557 52.9113L255.861 59.3435C256.07 59.9273 255.362 60.4636 254.741 60.4633C254.741 60.4633 251.757 60.1435 248.356 59.872L237.518 75.894Z",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 113,
    y: 35,
    width: 64,
    height: 64,
    rx: 32,
    fill: "#2F6FEB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M159.154 49.1543L134.539 84.8466",
    stroke: "white",
    strokeWidth: 2.46154,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.127 51.6152H149.522H141.072L135.977 51.6153C134.902 51.6153 134.228 52.5652 133.81 53.5561L131.11 59.9621C128.39 63.0389 128.388 64.7551 128.387 66.4084C128.387 66.5158 128.387 66.623 128.386 66.7302C128.386 66.7364 128.386 66.7427 128.385 66.7489C128.385 66.7555 128.385 66.7621 128.385 66.7687V66.9089V68.5313C128.385 70.3908 128.933 72.1235 130.08 73.3447V78.5447C130.08 79.3841 130.756 80.0597 131.595 80.0597H132.859C133.698 80.0597 134.374 79.3841 134.374 78.5447V74.1148H137.906L146.755 61.0348C146.162 61.0108 145.608 60.9972 145.119 60.9976C141.572 61.0005 134.505 61.7702 134.505 61.7702C134.008 61.7705 133.444 61.3424 133.609 60.8744L135.42 55.7287C135.585 55.2607 135.82 54.8328 136.316 54.8328H150.95L153.127 51.6152Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.214 74.1152H156.147V78.5451C156.147 79.3845 156.822 80.0601 157.662 80.0601H158.925C159.764 80.0601 160.44 79.3845 160.44 78.5451V73.4203C161.637 72.1955 162.21 70.4304 162.21 68.5317V66.9093C162.21 66.9009 162.21 66.8931 162.21 66.8852C162.21 66.8801 162.21 66.8749 162.21 66.8695V66.7691C162.21 66.7278 162.208 66.6871 162.207 66.6462C162.206 66.6339 162.205 66.6216 162.205 66.6092C162.203 66.4862 162.202 66.3655 162.2 66.2466C162.181 64.4004 162.166 62.9948 159.485 59.9625L156.785 53.5564C156.703 53.3619 156.611 53.1689 156.508 52.9844L154.894 55.371C154.951 55.4827 155.001 55.6045 155.045 55.7291L156.889 60.8748C157.056 61.3418 156.489 61.7709 155.993 61.7706C155.993 61.7706 153.606 61.5148 150.885 61.2976L142.214 74.1152Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 170.5,
    cy: 14.5,
    r: 1.5,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 159,
    y: 81,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M169.5 97L173.5 101L180.5 93",
    stroke: "#24284E",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 63,
    y: 81,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5 97L77.5 101L84.5 93",
    stroke: "#24284E",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 255,
    y: 81,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 271,
    cy: 97,
    r: 2,
    fill: "#24284E"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 263,
    cy: 97,
    r: 2,
    fill: "#24284E"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 279,
    cy: 97,
    r: 2,
    fill: "#24284E"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 4.5,
    r: 1.5,
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 103,
    cy: 2,
    r: 2,
    fill: "white"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 123,
    cy: 120,
    r: 2,
    fill: "white"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 111.5,
    r: 1.5,
    fill: "white"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 61.5,
    cy: 138.5,
    r: 1.5,
    fill: "white"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 260.5,
    cy: 135.5,
    r: 1.5,
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M271.5 22.5L279.5 10.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M205.5 118L195.5 129",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M208.5 21.5L201.5 10.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersistenceCarFreeDays);
export default __webpack_public_path__ + "static/media/persistence-car-free-days.cde2447c387be001c60ad26aeaff7e4d.svg";
export { ForwardRef as ReactComponent };